import _defineProperty from "C:\\vape\\crafty-control\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "C:\\vape\\crafty-control\\node_modules\\@babel\\runtime/regenerator";
import _possibleConstructorReturn from "C:\\vape\\crafty-control\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\vape\\crafty-control\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\vape\\crafty-control\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _classCallCheck from "C:\\vape\\crafty-control\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\vape\\crafty-control\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import React, { useContext, useRef, useEffect } from 'react';
import { defineCustomElements } from '@ionic/core/loader';
import { addIcons } from 'ionicons';
import { close, reorder, menu, arrowForward, arrowBack, arrowDown, search, closeCircle } from 'ionicons/icons';
import { isPlatform as isPlatform$1, getPlatforms as getPlatforms$1, alertController, loadingController, toastController, pickerController, actionSheetController, modalController, popoverController } from '@ionic/core';
export { setupConfig } from '@ionic/core';
import { __rest } from 'tslib';
import ReactDom from 'react-dom';
var IonLifeCycleContext =
/*@__PURE__*/
React.createContext({
  onIonViewWillEnter: function onIonViewWillEnter() {
    return;
  },
  ionViewWillEnter: function ionViewWillEnter() {
    return;
  },
  onIonViewDidEnter: function onIonViewDidEnter() {
    return;
  },
  ionViewDidEnter: function ionViewDidEnter() {
    return;
  },
  onIonViewWillLeave: function onIonViewWillLeave() {
    return;
  },
  ionViewWillLeave: function ionViewWillLeave() {
    return;
  },
  onIonViewDidLeave: function onIonViewDidLeave() {
    return;
  },
  ionViewDidLeave: function ionViewDidLeave() {
    return;
  }
});

var DefaultIonLifeCycleContext =
/*#__PURE__*/
function () {
  function DefaultIonLifeCycleContext() {
    _classCallCheck(this, DefaultIonLifeCycleContext);

    this.ionViewWillEnterCallbacks = [];
    this.ionViewDidEnterCallbacks = [];
    this.ionViewWillLeaveCallbacks = [];
    this.ionViewDidLeaveCallbacks = [];
  }

  _createClass(DefaultIonLifeCycleContext, [{
    key: "onIonViewWillEnter",
    value: function onIonViewWillEnter(callback) {
      if (callback.id) {
        var index = this.ionViewWillEnterCallbacks.findIndex(function (x) {
          return x.id === callback.id;
        });

        if (index > -1) {
          this.ionViewWillEnterCallbacks[index] = callback;
        } else {
          this.ionViewWillEnterCallbacks.push(callback);
        }
      } else {
        this.ionViewWillEnterCallbacks.push(callback);
      }
    }
  }, {
    key: "ionViewWillEnter",
    value: function ionViewWillEnter() {
      this.ionViewWillEnterCallbacks.forEach(function (cb) {
        return cb();
      });
    }
  }, {
    key: "onIonViewDidEnter",
    value: function onIonViewDidEnter(callback) {
      if (callback.id) {
        var index = this.ionViewDidEnterCallbacks.findIndex(function (x) {
          return x.id === callback.id;
        });

        if (index > -1) {
          this.ionViewDidEnterCallbacks[index] = callback;
        } else {
          this.ionViewDidEnterCallbacks.push(callback);
        }
      } else {
        this.ionViewDidEnterCallbacks.push(callback);
      }
    }
  }, {
    key: "ionViewDidEnter",
    value: function ionViewDidEnter() {
      this.ionViewDidEnterCallbacks.forEach(function (cb) {
        return cb();
      });
    }
  }, {
    key: "onIonViewWillLeave",
    value: function onIonViewWillLeave(callback) {
      if (callback.id) {
        var index = this.ionViewWillLeaveCallbacks.findIndex(function (x) {
          return x.id === callback.id;
        });

        if (index > -1) {
          this.ionViewWillLeaveCallbacks[index] = callback;
        } else {
          this.ionViewWillLeaveCallbacks.push(callback);
        }
      } else {
        this.ionViewWillLeaveCallbacks.push(callback);
      }
    }
  }, {
    key: "ionViewWillLeave",
    value: function ionViewWillLeave() {
      this.ionViewWillLeaveCallbacks.forEach(function (cb) {
        return cb();
      });
    }
  }, {
    key: "onIonViewDidLeave",
    value: function onIonViewDidLeave(callback) {
      if (callback.id) {
        var index = this.ionViewDidLeaveCallbacks.findIndex(function (x) {
          return x.id === callback.id;
        });

        if (index > -1) {
          this.ionViewDidLeaveCallbacks[index] = callback;
        } else {
          this.ionViewDidLeaveCallbacks.push(callback);
        }
      } else {
        this.ionViewDidLeaveCallbacks.push(callback);
      }
    }
  }, {
    key: "ionViewDidLeave",
    value: function ionViewDidLeave() {
      this.ionViewDidLeaveCallbacks.forEach(function (cb) {
        return cb();
      });
      this.componentCanBeDestroyed();
    }
  }, {
    key: "onComponentCanBeDestroyed",
    value: function onComponentCanBeDestroyed(callback) {
      this.componentCanBeDestroyedCallback = callback;
    }
  }, {
    key: "componentCanBeDestroyed",
    value: function componentCanBeDestroyed() {
      if (this.componentCanBeDestroyedCallback) {
        this.componentCanBeDestroyedCallback();
      }
    }
  }]);

  return DefaultIonLifeCycleContext;
}();

var withIonLifeCycle = function withIonLifeCycle(WrappedComponent) {
  return (
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(IonLifeCycle, _React$Component);

      function IonLifeCycle(props) {
        var _this;

        _classCallCheck(this, IonLifeCycle);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(IonLifeCycle).call(this, props));
        _this.componentRef = React.createRef();
        return _this;
      }

      _createClass(IonLifeCycle, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var element = this.componentRef.current;
          this.context.onIonViewWillEnter(function () {
            if (element && element.ionViewWillEnter) {
              element.ionViewWillEnter();
            }
          });
          this.context.onIonViewDidEnter(function () {
            if (element && element.ionViewDidEnter) {
              element.ionViewDidEnter();
            }
          });
          this.context.onIonViewWillLeave(function () {
            if (element && element.ionViewWillLeave) {
              element.ionViewWillLeave();
            }
          });
          this.context.onIonViewDidLeave(function () {
            if (element && element.ionViewDidLeave) {
              element.ionViewDidLeave();
            }
          });
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;

          return React.createElement(IonLifeCycleContext.Consumer, null, function (context) {
            _this2.context = context;
            return React.createElement(WrappedComponent, Object.assign({
              ref: _this2.componentRef
            }, _this2.props));
          });
        }
      }]);

      return IonLifeCycle;
    }(React.Component)
  );
};

var useIonViewWillEnter = function useIonViewWillEnter(callback) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var context = useContext(IonLifeCycleContext);
  var id = useRef();
  id.current = id.current || Math.floor(Math.random() * 1000000);
  useEffect(function () {
    callback.id = id.current;
    context.onIonViewWillEnter(callback);
  }, deps);
};

var useIonViewDidEnter = function useIonViewDidEnter(callback) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var context = useContext(IonLifeCycleContext);
  var id = useRef();
  id.current = id.current || Math.floor(Math.random() * 1000000);
  useEffect(function () {
    callback.id = id.current;
    context.onIonViewDidEnter(callback);
  }, deps);
};

var useIonViewWillLeave = function useIonViewWillLeave(callback) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var context = useContext(IonLifeCycleContext);
  var id = useRef();
  id.current = id.current || Math.floor(Math.random() * 1000000);
  useEffect(function () {
    callback.id = id.current;
    context.onIonViewWillLeave(callback);
  }, deps);
};

var useIonViewDidLeave = function useIonViewDidLeave(callback) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var context = useContext(IonLifeCycleContext);
  var id = useRef();
  id.current = id.current || Math.floor(Math.random() * 1000000);
  useEffect(function () {
    callback.id = id.current;
    context.onIonViewDidLeave(callback);
  }, deps);
};

var NavContext =
/*@__PURE__*/
React.createContext({
  getPageManager: function getPageManager() {
    return undefined;
  },
  getStackManager: function getStackManager() {
    return undefined;
  },
  goBack: function goBack(defaultHref) {
    if (defaultHref !== undefined) {
      window.location.pathname = defaultHref;
    } else {
      window.history.back();
    }
  },
  navigate: function navigate(path) {
    window.location.pathname = path;
  },
  tabNavigate: function tabNavigate() {
    return undefined;
  },
  hasIonicRouter: function hasIonicRouter() {
    return false;
  },
  registerIonPage: function registerIonPage() {
    return undefined;
  },
  currentPath: undefined
});

var dashToPascalCase = function dashToPascalCase(str) {
  return str.toLowerCase().split('-').map(function (segment) {
    return segment.charAt(0).toUpperCase() + segment.slice(1);
  }).join('');
};

var camelToDashCase = function camelToDashCase(str) {
  return str.replace(/([A-Z])/g, function (m) {
    return "-".concat(m[0].toLowerCase());
  });
};

var attachProps = function attachProps(node, newProps) {
  var oldProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  // some test frameworks don't render DOM elements, so we test here to make sure we are dealing with DOM first
  if (node instanceof Element) {
    // add any classes in className to the class list
    var className = getClassName(node.classList, newProps, oldProps);

    if (className !== '') {
      node.className = className;
    }

    Object.keys(newProps).forEach(function (name) {
      if (name === 'children' || name === 'style' || name === 'ref' || name === 'class' || name === 'className' || name === 'forwardedRef') {
        return;
      }

      if (name.indexOf('on') === 0 && name[2] === name[2].toUpperCase()) {
        var eventName = name.substring(2);
        var eventNameLc = eventName[0].toLowerCase() + eventName.substring(1);

        if (!isCoveredByReact(eventNameLc)) {
          syncEvent(node, eventNameLc, newProps[name]);
        }
      } else {
        node[name] = newProps[name];
        var propType = typeof newProps[name];

        if (propType === 'string') {
          node.setAttribute(camelToDashCase(name), newProps[name]);
        } else {
          node[name] = newProps[name];
        }
      }
    });
  }
};

var getClassName = function getClassName(classList, newProps, oldProps) {
  var newClassProp = newProps.className || newProps.class;
  var oldClassProp = oldProps.className || oldProps.class; // map the classes to Maps for performance

  var currentClasses = arrayToMap(classList);
  var incomingPropClasses = arrayToMap(newClassProp ? newClassProp.split(' ') : []);
  var oldPropClasses = arrayToMap(oldClassProp ? oldClassProp.split(' ') : []);
  var finalClassNames = []; // loop through each of the current classes on the component
  // to see if it should be a part of the classNames added

  currentClasses.forEach(function (currentClass) {
    if (incomingPropClasses.has(currentClass)) {
      // add it as its already included in classnames coming in from newProps
      finalClassNames.push(currentClass);
      incomingPropClasses.delete(currentClass);
    } else if (!oldPropClasses.has(currentClass)) {
      // add it as it has NOT been removed by user
      finalClassNames.push(currentClass);
    }
  });
  incomingPropClasses.forEach(function (s) {
    return finalClassNames.push(s);
  });
  return finalClassNames.join(' ');
};
/**
 * Checks if an event is supported in the current execution environment.
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */


var isCoveredByReact = function isCoveredByReact(eventNameSuffix) {
  var doc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in doc;

  if (!isSupported) {
    var element = doc.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  return isSupported;
};

var syncEvent = function syncEvent(node, eventName, newEventHandler) {
  var eventStore = node.__events || (node.__events = {});
  var oldEventHandler = eventStore[eventName]; // Remove old listener so they don't double up.

  if (oldEventHandler) {
    node.removeEventListener(eventName, oldEventHandler);
  } // Bind new listener.


  node.addEventListener(eventName, eventStore[eventName] = function handler(e) {
    if (newEventHandler) {
      newEventHandler.call(this, e);
    }
  });
};

var arrayToMap = function arrayToMap(arr) {
  var map = new Map();
  arr.forEach(function (s) {
    return map.set(s, s);
  });
  return map;
};

var createForwardRef = function createForwardRef(ReactComponent, displayName) {
  var forwardRef = function forwardRef(props, ref) {
    return React.createElement(ReactComponent, Object.assign({}, props, {
      forwardedRef: ref
    }));
  };

  forwardRef.displayName = displayName;
  return React.forwardRef(forwardRef);
};

var isPlatform = function isPlatform(platform) {
  return isPlatform$1(window, platform);
};

var getPlatforms = function getPlatforms() {
  return getPlatforms$1(window);
};

var getConfig = function getConfig() {
  if (typeof window !== 'undefined') {
    var Ionic = window.Ionic;

    if (Ionic && Ionic.config) {
      return Ionic.config;
    }
  }

  return null;
};

var createReactComponent = function createReactComponent(tagName) {
  var routerLinkComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var displayName = dashToPascalCase(tagName);

  var ReactComponent =
  /*#__PURE__*/
  function (_React$Component2) {
    _inherits(ReactComponent, _React$Component2);

    function ReactComponent(props) {
      var _this3;

      _classCallCheck(this, ReactComponent);

      _this3 = _possibleConstructorReturn(this, _getPrototypeOf(ReactComponent).call(this, props));

      _this3.handleClick = function (e) {
        var _this3$props = _this3.props,
            routerLink = _this3$props.routerLink,
            routerDirection = _this3$props.routerDirection;

        if (routerLink !== undefined) {
          e.preventDefault();

          _this3.context.navigate(routerLink, routerDirection);
        }
      };

      return _this3;
    }

    _createClass(ReactComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.componentDidUpdate(this.props);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var node = ReactDom.findDOMNode(this);
        attachProps(node, this.props, prevProps);
      }
    }, {
      key: "render",
      value: function render() {
        var _this4 = this;

        var _a = this.props,
            children = _a.children,
            forwardedRef = _a.forwardedRef,
            style = _a.style,
            className = _a.className,
            ref = _a.ref,
            cProps = __rest(_a, ["children", "forwardedRef", "style", "className", "ref"]);

        var propsToPass = Object.keys(cProps).reduce(function (acc, name) {
          if (name.indexOf('on') === 0 && name[2] === name[2].toUpperCase()) {
            var eventName = name.substring(2).toLowerCase();

            if (isCoveredByReact(eventName)) {
              acc[name] = cProps[name];
            }
          }

          return acc;
        }, {});
        var newProps = Object.assign({}, propsToPass, {
          ref: forwardedRef,
          style: style
        });

        if (routerLinkComponent) {
          if (this.props.routerLink && !this.props.href) {
            newProps.href = this.props.routerLink;
          }

          if (newProps.onClick) {
            var oldClick = newProps.onClick;

            newProps.onClick = function (e) {
              oldClick(e);

              if (!e.defaultPrevented) {
                _this4.handleClick(e);
              }
            };
          } else {
            newProps.onClick = this.handleClick;
          }
        }

        return React.createElement(tagName, newProps, children);
      }
    }], [{
      key: "displayName",
      get: function get() {
        return displayName;
      }
    }, {
      key: "contextType",
      get: function get() {
        return NavContext;
      }
    }]);

    return ReactComponent;
  }(React.Component);

  return createForwardRef(ReactComponent, displayName);
}; // ionicons


var IonIcon =
/*@__PURE__*/
createReactComponent('ion-icon'); // ionic/core

var IonApp =
/*@__PURE__*/
createReactComponent('ion-app');
var IonTab =
/*@__PURE__*/
createReactComponent('ion-tab');
var IonTabButton =
/*@__PURE__*/
createReactComponent('ion-tab-button');
var IonRouterLink =
/*@__PURE__*/
createReactComponent('ion-router-link', true);
var IonAvatar =
/*@__PURE__*/
createReactComponent('ion-avatar');
var IonBackdrop =
/*@__PURE__*/
createReactComponent('ion-backdrop');
var IonBadge =
/*@__PURE__*/
createReactComponent('ion-badge');
var IonButton =
/*@__PURE__*/
createReactComponent('ion-button', true);
var IonButtons =
/*@__PURE__*/
createReactComponent('ion-buttons');
var IonCard =
/*@__PURE__*/
createReactComponent('ion-card', true);
var IonCardContent =
/*@__PURE__*/
createReactComponent('ion-card-content');
var IonCardHeader =
/*@__PURE__*/
createReactComponent('ion-card-header');
var IonCardSubtitle =
/*@__PURE__*/
createReactComponent('ion-card-subtitle');
var IonCardTitle =
/*@__PURE__*/
createReactComponent('ion-card-title');
var IonCheckbox =
/*@__PURE__*/
createReactComponent('ion-checkbox');
var IonCol =
/*@__PURE__*/
createReactComponent('ion-col');
var IonContent =
/*@__PURE__*/
createReactComponent('ion-content');
var IonChip =
/*@__PURE__*/
createReactComponent('ion-chip');
var IonDatetime =
/*@__PURE__*/
createReactComponent('ion-datetime');
var IonFab =
/*@__PURE__*/
createReactComponent('ion-fab');
var IonFabButton =
/*@__PURE__*/
createReactComponent('ion-fab-button', true);
var IonFabList =
/*@__PURE__*/
createReactComponent('ion-fab-list');
var IonFooter =
/*@__PURE__*/
createReactComponent('ion-footer');
var IonGrid =
/*@__PURE__*/
createReactComponent('ion-grid');
var IonHeader =
/*@__PURE__*/
createReactComponent('ion-header');
var IonImg =
/*@__PURE__*/
createReactComponent('ion-img');
var IonInfiniteScroll =
/*@__PURE__*/
createReactComponent('ion-infinite-scroll');
var IonInfiniteScrollContent =
/*@__PURE__*/
createReactComponent('ion-infinite-scroll-content');
var IonInput =
/*@__PURE__*/
createReactComponent('ion-input');
var IonItem =
/*@__PURE__*/
createReactComponent('ion-item', true);
var IonItemDivider =
/*@__PURE__*/
createReactComponent('ion-item-divider');
var IonItemGroup =
/*@__PURE__*/
createReactComponent('ion-item-group');
var IonItemOption =
/*@__PURE__*/
createReactComponent('ion-item-option', true);
var IonItemOptions =
/*@__PURE__*/
createReactComponent('ion-item-options');
var IonItemSliding =
/*@__PURE__*/
createReactComponent('ion-item-sliding');
var IonLabel =
/*@__PURE__*/
createReactComponent('ion-label');
var IonList =
/*@__PURE__*/
createReactComponent('ion-list');
var IonListHeader =
/*@__PURE__*/
createReactComponent('ion-list-header');
var IonMenu =
/*@__PURE__*/
createReactComponent('ion-menu');
var IonMenuButton =
/*@__PURE__*/
createReactComponent('ion-menu-button');
var IonMenuToggle =
/*@__PURE__*/
createReactComponent('ion-menu-toggle');
var IonNote =
/*@__PURE__*/
createReactComponent('ion-note');
var IonPickerColumn =
/*@__PURE__*/
createReactComponent('ion-picker-column');
var IonNav =
/*@__PURE__*/
createReactComponent('ion-nav');
var IonProgressBar =
/*@__PURE__*/
createReactComponent('ion-progress-bar');
var IonRadio =
/*@__PURE__*/
createReactComponent('ion-radio');
var IonRadioGroup =
/*@__PURE__*/
createReactComponent('ion-radio-group');
var IonRange =
/*@__PURE__*/
createReactComponent('ion-range');
var IonRefresher =
/*@__PURE__*/
createReactComponent('ion-refresher');
var IonRefresherContent =
/*@__PURE__*/
createReactComponent('ion-refresher-content');
var IonReorder =
/*@__PURE__*/
createReactComponent('ion-reorder');
var IonReorderGroup =
/*@__PURE__*/
createReactComponent('ion-reorder-group');
var IonRippleEffect =
/*@__PURE__*/
createReactComponent('ion-ripple-effect');
var IonRow =
/*@__PURE__*/
createReactComponent('ion-row');
var IonSearchbar =
/*@__PURE__*/
createReactComponent('ion-searchbar');
var IonSegment =
/*@__PURE__*/
createReactComponent('ion-segment');
var IonSegmentButton =
/*@__PURE__*/
createReactComponent('ion-segment-button');
var IonSelect =
/*@__PURE__*/
createReactComponent('ion-select');
var IonSelectOption =
/*@__PURE__*/
createReactComponent('ion-select-option');
var IonSelectPopover =
/*@__PURE__*/
createReactComponent('ion-select-popover');
var IonSkeletonText =
/*@__PURE__*/
createReactComponent('ion-skeleton-text');
var IonSlide =
/*@__PURE__*/
createReactComponent('ion-slide');
var IonSlides =
/*@__PURE__*/
createReactComponent('ion-slides');
var IonSpinner =
/*@__PURE__*/
createReactComponent('ion-spinner');
var IonSplitPane =
/*@__PURE__*/
createReactComponent('ion-split-pane');
var IonText =
/*@__PURE__*/
createReactComponent('ion-text');
var IonTextarea =
/*@__PURE__*/
createReactComponent('ion-textarea');
var IonThumbnail =
/*@__PURE__*/
createReactComponent('ion-thumbnail');
var IonTitle =
/*@__PURE__*/
createReactComponent('ion-title');
var IonToggle =
/*@__PURE__*/
createReactComponent('ion-toggle');
var IonToolbar =
/*@__PURE__*/
createReactComponent('ion-toolbar');
var IonVirtualScroll =
/*@__PURE__*/
createReactComponent('ion-virtual-scroll');

var createControllerComponent = function createControllerComponent(displayName, controller) {
  var dismissEventName = "on".concat(displayName, "DidDismiss");
  return (
    /*#__PURE__*/
    function (_React$Component3) {
      _inherits(_class, _React$Component3);

      function _class(props) {
        var _this5;

        _classCallCheck(this, _class);

        _this5 = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
        _this5.isUnmounted = false;
        return _this5;
      }

      _createClass(_class, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var isOpen;
          return _regeneratorRuntime.async(function componentDidMount$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  isOpen = this.props.isOpen;

                  if (isOpen) {
                    this.present();
                  }

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, null, this);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.isUnmounted = true;

          if (this.overlay) {
            this.overlay.dismiss();
          }
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          return _regeneratorRuntime.async(function componentDidUpdate$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (prevProps.isOpen !== this.props.isOpen && this.props.isOpen === true) {
                    this.present(prevProps);
                  }

                  if (!(this.overlay && prevProps.isOpen !== this.props.isOpen && this.props.isOpen === false)) {
                    _context2.next = 4;
                    break;
                  }

                  _context2.next = 4;
                  return _regeneratorRuntime.awrap(this.overlay.dismiss());

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, null, this);
        }
      }, {
        key: "present",
        value: function present(prevProps) {
          var _a, isOpen, onDidDismiss, cProps;

          return _regeneratorRuntime.async(function present$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _a = this.props, isOpen = _a.isOpen, onDidDismiss = _a.onDidDismiss, cProps = __rest(_a, ["isOpen", "onDidDismiss"]);
                  _context3.next = 3;
                  return _regeneratorRuntime.awrap(controller.create(Object.assign({}, cProps)));

                case 3:
                  this.overlay = _context3.sent;
                  attachProps(this.overlay, _defineProperty({}, dismissEventName, onDidDismiss), prevProps); // Check isOpen again since the value could have changed during the async call to controller.create
                  // It's also possible for the component to have become unmounted.

                  if (!(this.props.isOpen === true && this.isUnmounted === false)) {
                    _context3.next = 8;
                    break;
                  }

                  _context3.next = 8;
                  return _regeneratorRuntime.awrap(this.overlay.present());

                case 8:
                case "end":
                  return _context3.stop();
              }
            }
          }, null, this);
        }
      }, {
        key: "render",
        value: function render() {
          return null;
        }
      }], [{
        key: "displayName",
        get: function get() {
          return displayName;
        }
      }]);

      return _class;
    }(React.Component)
  );
};

var IonAlert =
/*@__PURE__*/
createControllerComponent('IonAlert', alertController);
var IonLoading =
/*@__PURE__*/
createControllerComponent('IonLoading', loadingController);
var IonToast =
/*@__PURE__*/
createControllerComponent('IonToast', toastController);
var IonPicker =
/*@__PURE__*/
createControllerComponent('IonPicker', pickerController);

var createOverlayComponent = function createOverlayComponent(displayName, controller) {
  var dismissEventName = "on".concat(displayName, "DidDismiss");
  return (
    /*#__PURE__*/
    function (_React$Component4) {
      _inherits(_class2, _React$Component4);

      function _class2(props) {
        var _this6;

        _classCallCheck(this, _class2);

        _this6 = _possibleConstructorReturn(this, _getPrototypeOf(_class2).call(this, props));
        _this6.el = document.createElement('div');
        return _this6;
      }

      _createClass(_class2, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          if (this.props.isOpen) {
            this.present();
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this.overlay) {
            this.overlay.dismiss();
          }
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          return _regeneratorRuntime.async(function componentDidUpdate$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (prevProps.isOpen !== this.props.isOpen && this.props.isOpen === true) {
                    this.present(prevProps);
                  }

                  if (!(this.overlay && prevProps.isOpen !== this.props.isOpen && this.props.isOpen === false)) {
                    _context4.next = 4;
                    break;
                  }

                  _context4.next = 4;
                  return _regeneratorRuntime.awrap(this.overlay.dismiss());

                case 4:
                case "end":
                  return _context4.stop();
              }
            }
          }, null, this);
        }
      }, {
        key: "present",
        value: function present(prevProps) {
          var _a, children, isOpen, _a$onDidDismiss, onDidDismiss, cProps, elementProps, overlay;

          return _regeneratorRuntime.async(function present$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _a = this.props, children = _a.children, isOpen = _a.isOpen, _a$onDidDismiss = _a.onDidDismiss, onDidDismiss = _a$onDidDismiss === void 0 ? function () {
                    return;
                  } : _a$onDidDismiss, cProps = __rest(_a, ["children", "isOpen", "onDidDismiss"]);
                  elementProps = Object.assign({}, cProps, _defineProperty({}, dismissEventName, onDidDismiss));
                  _context5.next = 4;
                  return _regeneratorRuntime.awrap(controller.create(Object.assign({}, elementProps, {
                    component: this.el,
                    componentProps: {}
                  })));

                case 4:
                  overlay = this.overlay = _context5.sent;
                  attachProps(overlay, elementProps, prevProps);
                  _context5.next = 8;
                  return _regeneratorRuntime.awrap(overlay.present());

                case 8:
                case "end":
                  return _context5.stop();
              }
            }
          }, null, this);
        }
      }, {
        key: "render",
        value: function render() {
          return ReactDom.createPortal(this.props.children, this.el);
        }
      }], [{
        key: "displayName",
        get: function get() {
          return displayName;
        }
      }]);

      return _class2;
    }(React.Component)
  );
};

var IonActionSheet =
/*@__PURE__*/
createOverlayComponent('IonActionSheet', actionSheetController);
var IonModal =
/*@__PURE__*/
createOverlayComponent('IonModal', modalController);
var IonPopover =
/*@__PURE__*/
createOverlayComponent('IonPopover', popoverController);

var IonPage =
/*@__PURE__*/
function () {
  return (
    /*#__PURE__*/
    function (_React$Component5) {
      _inherits(IonPageInternal, _React$Component5);

      function IonPageInternal() {
        var _this7;

        _classCallCheck(this, IonPageInternal);

        _this7 = _possibleConstructorReturn(this, _getPrototypeOf(IonPageInternal).apply(this, arguments));
        _this7.ref = React.createRef();
        return _this7;
      }

      _createClass(IonPageInternal, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          if (this.context && this.ref.current) {
            if (this.context.hasIonicRouter()) {
              this.context.registerIonPage(this.ref.current);
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _a = this.props,
              className = _a.className,
              children = _a.children,
              props = __rest(_a, ["className", "children"]);

          return React.createElement("div", Object.assign({
            className: className ? "ion-page ".concat(className) : 'ion-page',
            ref: this.ref
          }, props), children);
        }
      }], [{
        key: "displayName",
        get: function get() {
          return 'IonPage';
        }
      }, {
        key: "contextType",
        get: function get() {
          return NavContext;
        }
      }]);

      return IonPageInternal;
    }(React.Component)
  );
}();

var IonTabBarInner =
/*@__PURE__*/
createReactComponent('ion-tab-bar');
var IonBackButtonInner =
/*@__PURE__*/
createReactComponent('ion-back-button');
var IonRouterOutletInner =
/*@__PURE__*/
createReactComponent('ion-router-outlet');

var IonRouterOutletContainer =
/*@__PURE__*/
function () {
  return (
    /*#__PURE__*/
    function (_React$Component6) {
      _inherits(_class3, _React$Component6);

      function _class3() {
        _classCallCheck(this, _class3);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class3).apply(this, arguments));
      }

      _createClass(_class3, [{
        key: "render",
        value: function render() {
          var StackManager = this.context.getStackManager();
          return this.context.hasIonicRouter() ? React.createElement(StackManager, null, React.createElement(IonRouterOutletInner, Object.assign({
            ref: this.props.forwardedRef
          }, this.props), this.props.children)) : React.createElement(IonRouterOutletInner, Object.assign({
            ref: this.props.forwardedRef
          }, this.props), this.props.children);
        }
      }], [{
        key: "contextType",
        get: function get() {
          return NavContext;
        }
      }]);

      return _class3;
    }(React.Component)
  );
}();

var IonRouterOutlet = createForwardRef(IonRouterOutletContainer, 'IonRouterOutlet');

var IonTabBarUnwrapped =
/*@__PURE__*/
function () {
  return (
    /*#__PURE__*/
    function (_React$Component7) {
      _inherits(_class4, _React$Component7);

      function _class4(props) {
        var _this8;

        _classCallCheck(this, _class4);

        _this8 = _possibleConstructorReturn(this, _getPrototypeOf(_class4).call(this, props));

        _this8.onTabButtonClick = function (e) {
          if (_this8.state.activeTab === e.detail.tab) {
            var originalHref = _this8.state.tabs[e.detail.tab].originalHref;

            if (_this8.context.hasIonicRouter()) {
              _this8.context.tabNavigate(originalHref);
            } else {
              _this8.context.navigate(originalHref, 'back');
            }
          } else {
            if (_this8.props.onIonTabsWillChange) {
              _this8.props.onIonTabsWillChange(new CustomEvent('ionTabWillChange', {
                detail: {
                  tab: e.detail.tab
                }
              }));
            }

            if (_this8.props.onIonTabsDidChange) {
              _this8.props.onIonTabsDidChange(new CustomEvent('ionTabDidChange', {
                detail: {
                  tab: e.detail.tab
                }
              }));
            }

            _this8.context.navigate(_this8.state.tabs[e.detail.tab].currentHref, 'none');
          }
        };

        _this8.renderChild = function (activeTab) {
          return function (child) {
            if (child != null && child.props && child.type === IonTabButton) {
              var href = child.props.tab === activeTab ? _this8.props.currentPath : _this8.state.tabs[child.props.tab].currentHref;
              return React.cloneElement(child, {
                href: href,
                onIonTabButtonClick: _this8.onTabButtonClick
              });
            }

            return null;
          };
        };

        var tabActiveUrls = {};
        React.Children.forEach(_this8.props.children, function (child) {
          if (child != null && typeof child === 'object' && child.props && child.type === IonTabButton) {
            tabActiveUrls[child.props.tab] = {
              originalHref: child.props.href,
              currentHref: child.props.href
            };
          }
        });
        _this8.state = {
          activeTab: undefined,
          tabs: tabActiveUrls
        };
        return _this8;
      }

      _createClass(_class4, [{
        key: "render",
        value: function render() {
          return React.createElement(IonTabBarInner, Object.assign({}, this.props, {
            selectedTab: this.state.activeTab
          }), React.Children.map(this.props.children, this.renderChild(this.state.activeTab)));
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(props, state) {
          var activeTab = Object.keys(state.tabs).find(function (key) {
            var href = state.tabs[key].originalHref;
            return props.currentPath.startsWith(href);
          });

          if (activeTab === undefined || activeTab === state.activeTab && state.tabs[activeTab].currentHref === props.currentPath) {
            return null;
          }

          return {
            activeTab: activeTab,
            tabs: Object.assign({}, state.tabs, _defineProperty({}, activeTab, {
              originalHref: state.tabs[activeTab].originalHref,
              currentHref: props.currentPath
            }))
          };
        }
      }, {
        key: "contextType",
        get: function get() {
          return NavContext;
        }
      }]);

      return _class4;
    }(React.Component)
  );
}();

var IonTabBar = function IonTabBar(props) {
  var context = useContext(NavContext);
  return React.createElement(IonTabBarUnwrapped, Object.assign({}, props, {
    currentPath: props.currentPath || context.currentPath
  }), props.children);
};

var hostStyles = {
  display: 'flex',
  position: 'absolute',
  top: '0',
  left: '0',
  right: '0',
  bottom: '0',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  contain: 'layout size style'
};
var tabsInner = {
  position: 'relative',
  flex: 1,
  contain: 'layout size style'
};

var IonTabs =
/*#__PURE__*/
function (_React$Component8) {
  _inherits(IonTabs, _React$Component8);

  function IonTabs(props) {
    var _this9;

    _classCallCheck(this, IonTabs);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(IonTabs).call(this, props));
    _this9.routerOutletRef = React.createRef();
    return _this9;
  }

  _createClass(IonTabs, [{
    key: "render",
    value: function render() {
      var _this10 = this;

      var outlet;
      var tabBar;
      React.Children.forEach(this.props.children, function (child) {
        if (child == null || typeof child !== 'object' || !child.hasOwnProperty('type')) {
          return;
        }

        if (child.type === IonRouterOutlet) {
          outlet = child;
        }

        if (child.type === IonTabBar) {
          var _this10$props = _this10.props,
              onIonTabsDidChange = _this10$props.onIonTabsDidChange,
              onIonTabsWillChange = _this10$props.onIonTabsWillChange;
          tabBar = React.cloneElement(child, {
            onIonTabsDidChange: onIonTabsDidChange,
            onIonTabsWillChange: onIonTabsWillChange
          });
        }
      });

      if (!outlet) {
        throw new Error('IonTabs must contain an IonRouterOutlet');
      }

      if (!tabBar) {
        // TODO, this is not required
        throw new Error('IonTabs needs a IonTabBar');
      }

      return React.createElement("div", {
        style: hostStyles
      }, tabBar.props.slot === 'top' ? tabBar : null, React.createElement("div", {
        style: tabsInner,
        className: "tabs-inner"
      }, outlet), tabBar.props.slot === 'bottom' ? tabBar : null);
    }
  }], [{
    key: "contextType",
    get: function get() {
      return NavContext;
    }
  }]);

  return IonTabs;
}(React.Component);

var IonBackButton =
/*@__PURE__*/
function () {
  return (
    /*#__PURE__*/
    function (_React$Component9) {
      _inherits(_class5, _React$Component9);

      function _class5() {
        var _this11;

        _classCallCheck(this, _class5);

        _this11 = _possibleConstructorReturn(this, _getPrototypeOf(_class5).apply(this, arguments));

        _this11.clickButton = function (e) {
          var defaultHref = _this11.props.defaultHref;

          if (_this11.context.hasIonicRouter()) {
            e.stopPropagation();

            _this11.context.goBack(defaultHref);
          } else if (defaultHref !== undefined) {
            window.location.href = defaultHref;
          }
        };

        return _this11;
      }

      _createClass(_class5, [{
        key: "render",
        value: function render() {
          return React.createElement(IonBackButtonInner, Object.assign({
            onClick: this.clickButton
          }, this.props));
        }
      }], [{
        key: "displayName",
        get: function get() {
          return 'IonBackButton';
        }
      }, {
        key: "contextType",
        get: function get() {
          return NavContext;
        }
      }]);

      return _class5;
    }(React.Component)
  );
}(); // Icons that are used by internal components


addIcons({
  'ios-close': close.ios,
  'md-close': close.md,
  'ios-reorder': reorder.ios,
  'md-reorder': reorder.md,
  'ios-menu': menu.ios,
  'md-menu': menu.md,
  'ios-arrow-forward': arrowForward.ios,
  'md-arrow-forward': arrowForward.md,
  'ios-arrow-back': arrowBack.ios,
  'md-arrow-back': arrowBack.md,
  'ios-arrow-down': arrowDown.ios,
  'md-arrow-down': arrowDown.md,
  'ios-search': search.ios,
  'md-search': search.md,
  'ios-close-circle': closeCircle.ios,
  'md-close-circle': closeCircle.md
}); // TODO: defineCustomElements() is asyncronous
// We need to use the promise

defineCustomElements(window);
export { DefaultIonLifeCycleContext, IonActionSheet, IonAlert, IonApp, IonAvatar, IonBackButton, IonBackdrop, IonBadge, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCheckbox, IonChip, IonCol, IonContent, IonDatetime, IonFab, IonFabButton, IonFabList, IonFooter, IonGrid, IonHeader, IonIcon, IonImg, IonInfiniteScroll, IonInfiniteScrollContent, IonInput, IonItem, IonItemDivider, IonItemGroup, IonItemOption, IonItemOptions, IonItemSliding, IonLabel, IonLifeCycleContext, IonList, IonListHeader, IonLoading, IonMenu, IonMenuButton, IonMenuToggle, IonModal, IonNav, IonNote, IonPage, IonPicker, IonPickerColumn, IonPopover, IonProgressBar, IonRadio, IonRadioGroup, IonRange, IonRefresher, IonRefresherContent, IonReorder, IonReorderGroup, IonRippleEffect, IonRouterLink, IonRouterOutlet, IonRow, IonSearchbar, IonSegment, IonSegmentButton, IonSelect, IonSelectOption, IonSelectPopover, IonSkeletonText, IonSlide, IonSlides, IonSpinner, IonSplitPane, IonTab, IonTabBar, IonTabButton, IonTabs, IonText, IonTextarea, IonThumbnail, IonTitle, IonToast, IonToggle, IonToolbar, IonVirtualScroll, NavContext, getConfig, getPlatforms, isPlatform, useIonViewDidEnter, useIonViewDidLeave, useIonViewWillEnter, useIonViewWillLeave, withIonLifeCycle };